import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import api from "../services/api.service";
import * as Styles from "../styles/Order.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

const OpenDeskOrderModal: React.FC<{
  desk: string;
  isOpen: boolean;
  onRequestClose: (clearField: boolean) => void;
  productsTransfer: any;
}> = ({ desk, isOpen, onRequestClose, productsTransfer }) => {
  const {
    subsidiaryDataZustand,
    setMessageZustand,
  } = useCombinedStore();

  const [orderOwnerUuid, setOrderOwnerUuid] = useState("");
  const [emailOptions, setEmailOptions] = useState<
    [{ userEmail: String; userUuid: String }]
  >([{ userEmail: "", userUuid: "" }]);
  const [peopleNumber, setPeopleNumber] = useState("1");
  const peopleNumberInputRef = useRef<HTMLInputElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (Number(peopleNumber) < 1) {
      setMessageZustand(
        'Não é possível abrir uma conta com menos de uma pessoa.',
        'error'
      )
      return
    }
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      const selectedDesk =
        subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.find(
          (deskItem: any) => deskItem.itemName === desk
        );
      const openOrderResponse = await api.post(`order`, {
        orderOwnerUuid: orderOwnerUuid,
        period: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid,
        orderType: "DESK",
        orderInfo: {
          peopleNumber: peopleNumber,
          deskUuid: selectedDesk.itemUuid,
        },
      });
      if (productsTransfer) {
        for (const productOrder of productsTransfer) {
          try {
            let productOrderData: {
              orderType: string;
              productUuid: any;
              productPrinted: boolean;
              productCode: string;
              productName: any;
              productPrice: any;
              productDiscount: string;
              peopleNumber?: string;
            } = {
              orderType: `DESK`,
              productUuid: productOrder.productUuid,
              productCode: String(productOrder.productCode),
              productPrinted: false,
              productName: productOrder.productName,
              productPrice: Number(productOrder.productPrice.replace(",", ".")),
              productDiscount: "0",
              peopleNumber: productOrder.people,
            };

            api.post(
              `addProductOrder/${openOrderResponse.data.order?.createdOrder.orderUuid}`,
              productOrderData
            );
          } catch (error: any) {
            if (error.message === "Network Error") {
              setMessageZustand(
                `Erro ao tentar incluir produto, entre em contato com os administradores do Alfredo da sua unidade.`,
                `error`
              );
            } else {
              setMessageZustand(
                `Erro ao incluir produto: ${error.message}`,
                `error`
              );
            }
          }
        }
      }
      setMessageZustand(
        `Pedido ${openOrderResponse.data.order?.createdOrder?.orderCode} aberto com sucesso!`,
        `success`
      );
      setPeopleNumber("1");
      onRequestClose(false);
    } catch (error: any) {
      if (error.message === "Network Error") {
        setMessageZustand(
          `Erro ao tentar abrir nova conta, entre em contato com os administradores do Alfredo da sua unidade.`,
          `error`
        );
      } else {
        setMessageZustand(
          `Erro ao abrir uma nova conta: ${error.message}`,
          `error`
        );
      }
    }
    setIsSubmitting(false);
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Atualizar o estado userEmail quando o dropdown for alterado
    const selectedUser = emailOptions.find(
      (userEmail) => userEmail.userEmail === e.target.value
    );
    setOrderOwnerUuid(String(selectedUser?.userUuid));
  };
  const GetUsers = async () => {
    try {
      const response = await api.get("/opsUsers");
      if (response.status !== 200) {
        throw new Error(response.data.message);
      }
      setEmailOptions(response.data);
      setOrderOwnerUuid(response.data[0].userUuid);
    } catch (error: any) {
      console.error("Erro ao buscar os usuários:", error);
    }
  };
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      if (document.activeElement === peopleNumberInputRef.current) {
        handleSubmit();
      } else {
        peopleNumberInputRef.current?.focus();
      }
    }
  };
  useEffect(() => {
    if (isOpen) {
      GetUsers();
      setTimeout(() => {
        modalWrapperRef.current?.focus();
        peopleNumberInputRef.current?.focus();
        peopleNumberInputRef.current?.select();
      }, 500);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose(true)}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton onClick={() => onRequestClose(true)}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor + "cc"
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Nova Conta</Styles.ModalTitle>
            <Styles.ModalDescription>{`Informe quem atenderá a mesa`}</Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.RowContainer>
              <Styles.FieldContainer>
                <Styles.DropdownInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <select onChange={handleEmailChange}>
                    {emailOptions?.map((userEmail: any) => (
                      <option
                        key={userEmail.userUuid}
                        value={userEmail.userEmail}
                      >
                        {userEmail.userEmail}
                      </option>
                    ))}
                  </select>
                  <label>Quem atenderá esta conta?</label>
                </Styles.DropdownInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Quantas pessoas estão na mesa?
              </Styles.FieldLabel>
              <Styles.FieldContainer>
                <Styles.NumberInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="number"
                    placeholder=""
                    ref={peopleNumberInputRef}
                    autoFocus={true}
                    value={peopleNumber}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setPeopleNumber(e.target.value)
                    }
                  />
                </Styles.NumberInput>
                <Styles.Unit
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  Pessoas
                </Styles.Unit>
              </Styles.FieldContainer>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor + "cc"
            }
          >
            <Styles.Button onClick={() => onRequestClose(true)}>
              Cancelar
            </Styles.Button>
            <Styles.Button onClick={handleSubmit}>Abrir Pedido</Styles.Button>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default OpenDeskOrderModal;
